// Timezone helpers — la Perla Music opera sempre in orario italiano (Europe/Rome).
// Se il browser del venditore è in un fuso diverso, mostriamo entrambi gli orari
// per evitare confusione ("14:30 🇮🇹 · 15:30 tua ora — Atene").

const ITALY_TZ = "Europe/Rome";

// Nome breve leggibile della TZ del browser (es. "Atene", "Bangkok", "Berlino").
export const getLocalTzLabel = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    // "Europe/Athens" -> "Athens"
    const short = tz.split("/").pop().replace(/_/g, " ");
    // Traduci alcune città comuni in italiano
    const map = {
      "Athens": "Atene",
      "Bangkok": "Bangkok",
      "Berlin": "Berlino",
      "Paris": "Parigi",
      "London": "Londra",
      "Madrid": "Madrid",
      "New York": "New York",
      "Los Angeles": "Los Angeles",
      "Dubai": "Dubai",
      "Bucharest": "Bucarest",
    };
    return map[short] || short;
  } catch (e) {
    return "";
  }
};

export const getLocalTzName = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch (e) { return ""; }
};

// True se il fuso del browser NON è quello italiano
export const isBrowserInItaly = () => {
  return getLocalTzName() === ITALY_TZ;
};

// Converte "HH:MM" in ora italiana → "HH:MM" nel fuso del browser.
// dateStr = "YYYY-MM-DD" (giorno di riferimento dell'appuntamento).
// Se ora locale è = ora italiana ritorna null (nessuna conversione da mostrare).
export const italianTimeToLocal = (dateStr, italianHHMM) => {
  if (!dateStr || !italianHHMM || isBrowserInItaly()) return null;
  try {
    // Costruiamo una data ISO come se l'orario fosse in Europe/Rome.
    // Trucco: calcoliamo l'offset di Rome per quella data e generiamo un ISO valido.
    const [h, m] = italianHHMM.split(":").map((x) => parseInt(x, 10));
    if (isNaN(h) || isNaN(m)) return null;
    // Prendiamo l'offset in minuti di Europe/Rome per questa data:
    // creiamo una data UTC e chiediamo cosa restituisce Intl per Europe/Rome
    const isoUtc = `${dateStr}T${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00Z`;
    const probe = new Date(isoUtc);
    // Offset Rome (minuti): differenza tra ora Rome e UTC
    const romeStr = new Intl.DateTimeFormat("en-GB", {
      timeZone: ITALY_TZ,
      hour: "2-digit", minute: "2-digit", hour12: false,
    }).format(probe);
    const [romeH, romeM] = romeStr.split(":").map((x) => parseInt(x, 10));
    const romeMinutesFromUtc = romeH * 60 + romeM;
    const utcMinutes = probe.getUTCHours() * 60 + probe.getUTCMinutes();
    let romeOffset = romeMinutesFromUtc - utcMinutes;
    if (romeOffset > 720) romeOffset -= 1440;
    if (romeOffset < -720) romeOffset += 1440;
    // La data "reale" dell'appuntamento in UTC:
    const realUtc = new Date(probe.getTime() - romeOffset * 60000);
    // Ora rendiamo nel fuso locale del browser
    return new Intl.DateTimeFormat("it-IT", {
      hour: "2-digit", minute: "2-digit", hour12: false,
    }).format(realUtc);
  } catch (e) {
    return null;
  }
};

// Ritorna offset ore (int, signed) del browser rispetto a Europe/Rome per la data data.
export const hoursOffsetFromItaly = (dateStr) => {
  if (!dateStr || isBrowserInItaly()) return 0;
  const localHHMM = italianTimeToLocal(dateStr, "12:00");
  if (!localHHMM) return 0;
  const [lh, lm] = localHHMM.split(":").map((x) => parseInt(x, 10));
  const localMin = lh * 60 + lm;
  const romeMin = 12 * 60;
  const diff = Math.round((localMin - romeMin) / 60);
  return diff;
};
